module.exports = __webpack_public_path__ + "static/media/mstile-144x144.c8166ba3.png";